export type ThemeChoice = "system" | "light" | "dark";

const KEY = "b2c-theme";

export function readTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(choice: ThemeChoice) {
  const root = document.documentElement;
  if (choice === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", choice);
  try {
    if (choice === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    /* armazenamento indisponível: o tema vale só para esta visita */
  }
}

export const nextTheme = (c: ThemeChoice): ThemeChoice =>
  c === "system" ? "dark" : c === "dark" ? "light" : "system";
export const THEME_LABEL: Record<ThemeChoice, string> = {
  system: "Tema: automático",
  dark: "Tema: escuro",
  light: "Tema: claro",
};
